<div class="stsdocs-global-container">
        <!-- <div class="stsdocs-global-header">
            <mat-toolbar class="stsdocs-global-header-title-container">
                <h1 class="stsdocs-global-header-title-text">Secure Transfer Service Docs</h1>
            </mat-toolbar>
        </div> -->
    <app-sidenav></app-sidenav>
    <div class="stsdocs-global-footer">
        <footer>
            Copyright &copy; 2026 Cisco Systems, Inc. and its affiliates. All rights reserved.
        </footer>
    </div>
</div>